module.exports = __webpack_public_path__ + "img/04@2x.37b1db0c.png";